import React from "react";
import NavAndHero from "../components/NavAndHero";
import CallToAction from "../components/CTA";
import Footer from "../components/Footer";
import { ReactComponent as BrandingImage } from "../images/undraw_empty_4zx0 (1).svg"; // swap as needed

const WebsiteBrandingPage = () => {
  return (
    <div data-theme="light">
      <NavAndHero />

      {/* Intro Section */}
      <section className="bg-blue-500 rounded-b-3xl py-20 px-4 text-center">
        <div className="max-w-3xl mx-auto space-y-6">
          <h1 className="text-4xl md:text-5xl font-bold text-white">
            Website & Branding Services
          </h1>
          <p className="text-lg text-gray-100">
            Build a powerful, consistent digital identity. From your logo to your landing page, we make your brand stand out, and unforgettable.
          </p>
        </div>
      </section>

      {/* Details Section */}
      <section className="py-20 px-4 bg-base-100">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-7xl mx-auto items-center">
          {/* Text */}
          <div className="space-y-4">
            <h2 className="text-3xl font-bold text-blue-500">What We Deliver</h2>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>Custom Website Design (Responsive & Optimized)</li>
              <li>Brand Identity Creation (Logos, Colors, Typography)</li>
              <li>Search Engine Optimization (SEO)</li>
              <li>UI/UX Design with Wireframes</li>
              <li>Landing Pages & Marketing Funnels</li>
            </ul>
          </div>

          {/* Image */}
          <div className="flex justify-center">
            <BrandingImage className="w-full max-w-md h-auto" />
          </div>
        </div>
      </section>

      {/* Benefits Section (Optional) */}
      <section className="bg-blue-100 py-20 px-4">
        <div className="max-w-6xl mx-auto text-center space-y-10">
          <h2 className="text-3xl font-bold text-blue-500">Why Choose Digiscape?</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 text-left">
            <div>
              <h3 className="text-xl font-semibold">🎨 Tailored Designs</h3>
              <p className="text-gray-700">
                No templates. Every site is uniquely crafted to match your brand and audience.
              </p>
            </div>
            <div>
              <h3 className="text-xl font-semibold">📱 Fast & Mobile-Ready</h3>
              <p className="text-gray-700">
                Built for performance and responsive across all devices.
              </p>
            </div>
            <div>
              <h3 className="text-xl font-semibold">⭐️ Creative + Strategic</h3>
              <p className="text-gray-700">
                We combine eye-catching design with marketing strategy that drives results.
              </p>
            </div>
          </div>
        </div>
      </section>

      <div id="cta">
        <CallToAction />
      </div>
      <Footer />
    </div>
  );
};

export default WebsiteBrandingPage;
